import styled from 'styled-components'

export const InvoiceGrid = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  row-gap: 30px;
  grid-template-areas:
    'billingFrom details details'
    'billingTo details details'
    'items items items';
  align-items: start;
  section {
    div {
      padding: 4px 0;
    }
  }
  .billingFrom {
    grid-area: billingFrom;
  }
  .billingTo {
    grid-area: billingTo;
  }
  .details {
    grid-area: details;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 'header detail';
  }
  .items {
    grid-area: items;
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-template-areas: 'description amount';
  }
`
